import React from 'react';
import {
    Link, LinkingIOS
} from 'react-router-dom';
import RegisterClasses from './RegisterClasses';
import DatePickerDropdown from './DatePickerDropdown';
import moment from 'moment';
import '../App.css';
import config from '.././config';
import $, { unique } from 'jquery';
import {
    Form, Input, Select, Checkbox,
    Steps, DatePicker, Modal, Table, Icon, Menu, Alert, Radio, Row, Col, Spin, Button, Highlighter, Card
} from 'antd';
import usStates from '../usStates';
import Admin from '../Admin/Admin';


const Step = Steps.Step;
const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;

const convertClassModeIDtoName = (id) => {
    console.log(id)
    return id === 1 ? 'Online' : (id === 2 ? 'In Person' : 'Hybrid');
}

//Form Layouts
const columnsExtClass = [{
    title: 'Class',
    dataIndex: 'Name',
    key: 'Name',
}
];

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
    },
};

const shortFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 4 },
        sm: { span: 3 },
    },
};

const midFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 8 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 6,
        },
    },
};


//
class RegistrationForm extends React.Component {



    constructor(props) {
        super(props);
        this.state.student = {
            Id: -1, FirstName: '', MiddleInitial: '', LastName: '', DLN: '', DateofBirth: '',
            StreetAddress: '', State: 'ND', City: '', ZipCode: '', PhoneNumber: '', Email: '', TechID: 'To be assigned', SComments: ''
        };
        this.state.employer = {
            Id: -1, CompanyName: '', Address: '', State: '',
            City: '', ZipCode: '', PhoneNumber: '', Email: ''
        };
        this.state.attendanceMap = new Map();
        this.state.onlineDisable = false;
        this.state.personDisable = false;

        this.register = { student: this.state.selectedStudents, employer: this.state.selectedStuEmp };
        this.DobUser = '';
        this.state.employerList = [];
        this.employerDisplayList = [];
        //this.companydropdown = '';
        //this.userButtton = "Already Registered before!";
        this.state.lastNameArr = [];
        this.state.initialModal = true;
        // State dropdown
        this.stateList = usStates.listofUSstates();
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getallemployer`,
        })
            .done((data) => {

                this.employerList = data;
                //adding N/A employer to top of list
                //this.employerDisplayList.push(<Option key={344}>{"Employer Not Selected"}</Option>);

                for (let i = 0; i < data.length; i++) {
                    if (data[i].Id != 344) {  //dont add repeating 344 ID employer not found
                        var optDis = data[i].CompanyName + ", " + data[i].City + " (" + data[i].State + ")";
                        //this is populating the dropdown for employers
                        this.employerDisplayList.push(
                            <Option key={data[i].Id}>{optDis}</Option>
                        );
                    }
                }
            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getall`
        })
            .done((data) => {
                this.state.studentData = data
                var seenNames = {};
                this.array = data;
                this.array = this.array.filter(function (currentObject) {
                    if (currentObject.LastName in seenNames) {
                        return false;
                    } else {
                        seenNames[currentObject.LastName] = true;
                        return true;
                    }
                });
                this.state.lastNameArr = this.array;
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.err('failed to get data');
            });


    }

    //Columns for selected table
    columnsSelect = () => {
        return ([{
            title: 'Class',
            dataIndex: 'Name',
            key: 'Name',
        }, {
            title: 'Category',
            dataIndex: 'CategoryName',
            key: 'CategoryName',
        }, {
            title: 'Starts',
            dataIndex: 'StartDate',
            key: 'StartDate',
            render: (text, record, index) => {
                if (record.SystemName == "ESCC") {
                    return (
                        <span>
                            {moment(text).format('l')}
                        </span>
                    );

                }
                else {
                    return (
                        <span>
                            {moment(text).format('l [at] h:mm A z')}
                        </span>
                    );
                }
            }
        }, {
            title: 'Ends',
            dataIndex: 'EndDate',
            key: 'EndDate',
            render: (text, record, index) => {
                return (
                    <span>
                        {moment(text).format('l')}
                    </span>
                );
            }
        },
        {
            title: 'Cost',
            dataIndex: 'Cost',
            key: 'Cost',
        },
        {
            title: 'Venue',
            dataIndex: 'Venue',
            key: 'Venue',
            render: (text, record, index) => {
                var url = record.VenueURL;
                if (url === '') {
                    return (
                        <span>
                            {text}
                        </span>
                    );
                }

                else {
                    // regex is checking if url has ftp || http(s) on front
                    if (!/^(?:f|ht)tps?\:\/\//.test(record.VenueURL)) {
                        url = 'http://' + record.VenueURL;
                    }
                    return (
                        <span>
                            <a target="_blank" href={url}> {text}</a>
                        </span>
                    );

                }


            }
        },
        {
            title: 'Address',
            dataIndex: 'Address',
            key: 'Address',
        },
        {
            title: 'Seats Available',
            dataIndex: 'Capacity',
            key: 'Capacity',
            render: (text, record, index) => {
                // online capacity is N/A for all non-hybrid courses
                if (record.OnlineCapacity === 'N/A') {
                    return (<span>{text}</span>);
                } else {
                    return (<span>In Person: {record.Capacity} <br /> Online: {record.OnlineCapacity}</span>)
                }
            }
        },
        {
            title: 'Comments',
            dataIndex: 'Comments',
            render: (text, record, index) => {
                if (record.Comments) {
                    return (
                        <div className="editable-row-operations">
                            <span>
                                <a onClick={() => Modal.info({
                                    title: record.Comments, onOk() { },
                                })}>More Info</a>
                            </span>
                        </div>
                    );
                }
            }
        }])
    }

    handleSelectClassModeChoice = (newClassMode, record) => {
        this.state.attendanceMap.set(record.StudentId, newClassMode)
    }


    //function to get system name from url
    getParameterByName(name, url) {
        if (!url) {
            url = window.location.href;
        }
        // replace all [, ] with \&? $ means end of string
        name = name.replace(/[\[\]]/g, "\\$&");
        // ? or & conact name concat = (anything except &|# * times) or & or # or end 
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    // State variables
    state = ({
        current: 0,
        filterSystem: "None",
        currentMenu: "Yes",
        //userVisible: false,
        classData: [],
        //filledMenuDisplay: false,
        confirmDirty: '',
        classDataKeys: [],
        inputControl: true,
        searchClassData: '',
        emailValue: "Both",
        emailValidatorUser: '',
        emailValidatorInfo: '',
        emailValidatorEmployer: '',
        loading: false,
        selectedRowKeys: [],
        selectedRows: [],
        topSelectedRows: [],
        //existingButton: "Start new registration",
        hideTextbox: true,
        //isUserNew: true,
        employerNotList: false,

        selectedStudents: [],
        selectedStuEmp: [],
        selectedEmpList: [],

        studentData: [],
        filteredStudentData: [],

        searchText: "",
        searchedColumn: ""

    });

    /**
    *  Renders the transition and steps
    */
    render() {
        const steps = [{
            title: 'Select Classes',
        },
        {
            title: 'Students Info',
        },
        {
            title: 'Verification',
        }
        ];
        let page = null;
        if (this.state.current === 0) {
            page = this.firstPage();
        }
        else if (this.state.current === 1) {
            page = this.secondPage();
        }
        else if (this.state.current === 2) {
            if (Admin.isAdminLoggedIn()) {
                page = this.adminThird();
            } else {
                page = this.thirdPage();
            }
        }
        else if (this.state.current === 3) {
            page = this.addUser();
        }
        const { current } = this.state;
        return (
            <div className="color3">
                <div style={{ color: 'red', fontSize: '1.5em', textAlign: 'center', paddingBottom: '5%' }}>
                    Please only register for classes using Microsoft Edge or Google Chrome.
                </div>
                <Steps current={current}>
                    {steps.map(item =>
                        <Step key={item.title} title={item.title} />
                    )}
                </Steps>
                <div>
                    <Form style={{ marginTop: 20 }}>
                        {page}
                    </Form>
                </div>
                <div className="steps-action">
                    {/*Renders Previous*/}
                    {
                        (this.state.current > 0)
                            ?
                            <button type="submit" className="btn btn-default color2" onClick={() => this.prev()}>
                                Previous
                            </button>
                            :
                            <button type="submit" className="btn btn-default color2" disabled style={{ visibility: "hidden" }}>
                                Previous
                            </button>

                    }
                    {/*Renders Next*/}
                    {
                        this.buttonHandler(steps)
                    }
                    {/*htmlType="submit" size="large"*/}
                    <center><a target="_blank" href='https://forms.nd.gov/231086668767875'>Contact: Technical Certification Program (TCP)</a>&emsp;&emsp;<a target="_blank" href='https://forms.nd.gov/231105789465866'>Contact: Erosion and Sediment Control (ESCC)</a></center>
                </div>
            </div>
        );
    }

    // Display button
    buttonHandler = (steps) => {
        if (this.state.current == 0) {
            return (<button className="btn btn-default" style={{ marginLeft: 10, float: 'right' }} onClick={() => this.next()}>Next</button>);
        }
        else if (this.state.current == 1) {
            if (this.state.selectedStudents.length < 1) {
                return (<button className="btn btn-default" style={{ marginLeft: 10, float: 'right' }} onClick={() => this.setState({ current: 3 })}>Register New Student</button>);
            } else {
                return (<button className="btn btn-default" style={{ marginLeft: 10, float: 'right' }} onClick={() => this.next()}>Next</button>);
            }
        }
        else if (this.state.current == 2) {
            return (<button className="btn btn-default" onClick={() => this.handleSubmit()} style={{ float: 'right' }}>Register</button>);

        }
    }
    mapToList(map) {
        var values = []
        for (let val of map.values()) {
            values.push(val)
        }
        return values;
    }

    /**
 * Final submit handler
 */
    handleSubmit = async (e) => {
        //e.preventDefault();
        for (let x = 0; x < this.state.selectedStudents.length; x++) {
            this.state.selectedStudents[x].Id = this.state.selectedStudents[x].StudentId
        }
        var promise = new Promise(async (res, rej) => {
            if (this.state.classData.length != 0) {
                this.setState({
                    loading: true
                });
                let attendList = [];
                for (let x = 0; x < this.state.selectedStudents.length; x++) {
                    attendList.push(convertClassModeIDtoName(this.state.classData[0].ClassModeID))
                }
                //.net server handles registration logic
                await $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/registration/addExisting`,
                    data: { students: this.state.selectedStudents, cls: this.state.classData[0].Id, emailOption: this.state.emailValue, chosenAttendance: this.state.classData[0].ClassModeID == 3 ? this.mapToList(this.state.attendanceMap) : attendList }
                })
                    .done((data) => {
                        res(data)
                    })
                    .fail((jqXhr) => {
                        console.err('failed to register ');
                        this.setState({
                            loading: false
                        });
                    });
                res(0);
            }
        }).then(async (data) => {
            if (data.alreadyEnrolled.length != 0 || data.failedStudents.length != 0) {
                var registerString = "";
                var failString = "";
                if (data.alreadyEnrolled.length != 0) {
                    for (var i = 0; i < data.alreadyEnrolled.length; i++) {
                        registerString += data.alreadyEnrolled[i].FirstName + " " + data.alreadyEnrolled[i].LastName + ", ";
                    }
                    registerString += " are already registered for the class."
                }
                if (data.failedStudents.length != 0) {
                    for (var i = 0; i < data.failedStudents.length; i++) {
                        failString += data.failedStudents[i].FirstName + " " + data.failedStudents[i].LastName + ", "
                    }
                    failString += " failed to register the class. "
                }
                var cn;
                if (data.failedStudents.length + data.alreadyEnrolled.length == this.state.selectedStudents.length) {
                    cn = registerString + "\n" + failString + "\n Class registration failed for all students"
                } else {
                    cn = registerString + "\n" + failString + "\n Class registration successful for other students"
                }
                const modal3 = Modal.info({
                    title: "Some Registrations were not Success",
                    content: cn,
                    onOk() {
                        if (Admin.isAdminLoggedIn()) {
                            window.location.hash = "/admin/admin"
                        } else {
                            window.location.reload();
                        }
                    },
                });
            }
            else {
                const modal = Modal.success({
                    title: "Class registration successful!",
                    content: 'Email with more information will be sent to you.',
                    onOk() {
                        if (Admin.isAdminLoggedIn()) {
                            window.location.hash = "/admin/admin"
                        } else {
                            window.location.reload();
                        }
                    }

                });
            }
        })
    }


    // Perform tasks when clicked next
    next() {
        this.setState({ visible: false });
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const current = this.state.current + 1;
                if (current === 1) {
                    if (this.state.classData[0] == undefined) {
                        alert("Please select a valid class")
                        return;
                    }
                    alert("You have selected Multiple Student Registration, so you can search for several students and select them from the bottom list. If you selected a hybrid class, you also need to select their mode of attendance from the top list.")
                    this.setState({
                        selectedStudents: JSON.parse(JSON.stringify(this.state.selectedRows)),
                        current: current,
                    });
                }
                else {
                    this.setState({ currentMenu: 'Yes' });
                }

                if (current === 2) {
                    var selectedStudentIds = this.state.selectedStudents.map((student) => student.Id)
                    if (selectedStudentIds.length > 0) {
                        if (this.state.classData[0].ClassModeID == 3) {
                            let oCount = 0;
                            let iCount = 0;
                            for (let val of this.state.attendanceMap.values()) {
                                if (val == "Online") {
                                    oCount++;
                                } else {
                                    iCount++;
                                }
                            }

                            if (oCount > parseInt(this.state.classData[0].OnlineCapacity)) {
                                alert("You have selected too many students to attend online, please remove some or change their attendance type.")
                                return;
                            }
                            if (iCount > parseInt(this.state.classData[0].Capacity)) {
                                alert("You have selected too many students to attend in person, please remove some or change their attendance type.")
                                return;
                            }
                            for (let x = 0; x < this.state.selectedStudents.length; x++) {
                                if (this.state.attendanceMap.get(this.state.selectedStudents[x].StudentId) == undefined) {
                                    alert("You must select an attendance mode for each student selected.")
                                    return;
                                }
                            }
                        } else {
                            if (this.state.selectedStudents.length > parseInt(this.state.classData[0].Capacity)) {
                                alert("You have selected more students to attend than the class can hold, please remove some.")
                                return;
                            }

                        }
                        this.setState({
                            current: current,
                        });
                        $.ajax({
                            type: 'GET',
                            url: `${config.serverUrl}/api/employer/getStudentsEmployers`,
                            data: {
                                ids: selectedStudentIds
                            },
                        })
                            .done((data) => {
                                this.setState({
                                    selectedStuEmp: data
                                });
                            })
                            .fail((jqXhr) => {
                                console.err('failed to get employer');
                            });
                    } else {
                        alert("Atleast one student must be selected")
                    }
                }
            }
        });
    }

    // Perform Tasks when clicked previous
    prev() {
        let current;
        if (this.state.current == 3) {
            current = 1;
        } else {
            current = this.state.current - 1;
        }
        this.setState({ current });
        if (current === 0) {
            this.setState({ currentMenu: 'Yes', selectedRowKeys: [], selectedRows: [], selectedStudents: [] })
        }
        if (current === 1) {
            this.state.attendanceMap.clear();
            this.setState({ currentMenu: 'Yes', selectedRowKeys: [], selectedRows: [], selectedStudents: [], });
            this.register = { student: [], employer: [] };
        }
    }

    // First page class search
    searchClass = () => {
        this.setState({
            searchClassData: this.props.form.getFieldValue("search")
        });

    }
    searchClassReset = () => {
        this.props.form.setFieldsValue({
            ['search']: '',
        });
        this.setState({
            searchClassData: ''
        });

    }


    /**
    * First Page - Select classes
    */
    firstPage = () => {
        const { getFieldDecorator } = this.props.form;
        /*------------------------------------------ Register for some Classes! ------------------------------------------*/
        return (
            <div className='forms'>
                {this.state.initialModal && <Modal
                    visible={true}
                    title={"Which system are you looking to use?"}
                    onCancel={() => this.setState({ initialModal: false })}
                    footer={<div></div>}
                >
                    <div style={{ textAlign: 'center' }}>
                        <button style={{ backgroundColor: '#042657', color: 'white', margin: '10px' }} className="btn btn-default" key="back" size="large" onClick={() => this.setState({ initialModal: false, filterSystem: "TCP" })}>
                            TCP
                        </button>
                        <button style={{ backgroundColor: '#cf4520', color: 'white' }} className="btn btn-default" key="submit" type="primary" size="large" onClick={() => this.setState({ initialModal: false, filterSystem: "ESCC" })}>
                            ESCC
                        </button>
                        <button style={{ backgroundColor: '#042657', color: 'white', margin: '10px' }} className="btn btn-default" key="submit" type="primary" size="large" onClick={() => this.setState({ initialModal: false, filterSystem: "External Civil Rights Training" })}>
                            Civil Rights
                        </button>
                    </div>
                </Modal>}
                <FormItem
                    label="Certification System"
                    {...formItemLayout}>
                    {getFieldDecorator('system', {
                        initialValue: this.state.filterSystem
                    })(
                        <Select
                            placeholder="Select a system to register for."
                            onChange={this.handleSelectChangeSystem}>
                            <Option value="All">All</Option>
                            <Option value="TCP">TCP</Option>
                            <Option value="ESCC">ESCC</Option>
                            <Option value="External Civil Rights Training">External Civil Rights Training</Option>
                        </Select>
                    )}
                </FormItem>
                {/* TODO: Add classes here. */}
                <FormItem>
                    <RegisterClasses systemFilter={this.state.filterSystem} getData={this.setSelectedData} renderData={this.state.classDataKeys} searchName={this.state.searchClassData} multiStudent={true} />
                </FormItem>
                <FormItem>
                    <Table rowKey="Id" columns={this.columnsSelect()} dataSource={this.state.classData} size="small" bordered />
                </FormItem>
                <br />
            </div>
        );
    }

    addUser = () => {
        if (this.companydropdown == 403 || this.companydropdown == "Employer Not Listed, N/A (ND)") {
            this.state.employerNotList = true;
        }
        else {
            this.state.employerNotList = false;
        }
        if (this.companydropdown == 403 || this.companydropdown == "Employer Not Listed, N/A (ND)") {
            if (this.state.classData[0].SystemName == "TCP") {
                this.state.employer.Email = "staylor@nd.gov";
            }
            else if (this.state.classData[0].SystemName == "ESCC") {
                this.state.employer.Email = "msperry@nd.gov";
            } else if (this.state.classData[0].SystemName == "External Civil Rights Training") {
                this.state.employer.Email = "civilrights@nd.gov";
            }
        }

        const { getFieldDecorator } = this.props.form;
        return (
            <div className='forms'>
                {/*------------------------------------------ User Details ------------------------------------------*/}
                <FormItem {...formItemLayout} label="First Name" >
                    {getFieldDecorator('fname', {
                        initialValue: this.state.student.FirstName,
                        rules: [{
                            required: true, message: 'Please input your first name!',
                        }],
                    })(<Input />)}
                </FormItem>
                {/*TODO: Limit one character*/}
                <FormItem {...shortFormItemLayout} label="Middle Initial" >
                    {getFieldDecorator('mname', {
                        initialValue: this.state.student.MiddleInitial,
                        rules: [{
                            required: false, message: 'Please input your middle initial!',
                        }],
                    })(<Input />)}
                </FormItem>
                <FormItem {...formItemLayout} label="Last Name" >
                    {getFieldDecorator('lname', {
                        initialValue: this.state.student.LastName,
                        rules: [{
                            required: true, message: 'Please input your last name!',
                        }],
                    })(<Input />)}
                </FormItem>
                <FormItem
                    {...formItemLayout} label="Date of Birth">
                    {getFieldDecorator('dob', {
                        initialValue: this.state.student.DateofBirth,
                        rules: [{
                            required: true, message: 'Please enter your date of birth!',
                        }],
                    })(

                        <DatePickerDropdown isUserNew={this.state.isUserNew} getDOBNew={this.getDateOfBirthNew} sendUserData={this.state.student.DateofBirth} />
                    )}
                </FormItem>
                {/*------------------------------------------ ADDRESS ------------------------------------------*/}
                <FormItem {...formItemLayout} label="Street">
                    {getFieldDecorator('street', {
                        initialValue: this.state.student.StreetAddress,
                        rules: [{
                            required: true, message: 'Please input street!',
                        }],
                    })(<Input />)}
                </FormItem>
                <FormItem {...formItemLayout} label="City" >
                    {getFieldDecorator('city', {
                        initialValue: this.state.student.City,
                        rules: [{
                            required: true, message: 'City',
                        }],
                    })(<Input />)}
                </FormItem>

                <FormItem {...formItemLayout} label="State">
                    {getFieldDecorator('state', {
                        initialValue: this.state.student.State,
                        rules: [
                            { required: true, message: 'Please select your country!' },
                        ],
                    })(
                        <Select
                            showSearch
                            style={{ width: '40%' }}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.stateList}
                        </Select>)}
                </FormItem>

                <FormItem {...midFormItemLayout} label="Zip Code">
                    {getFieldDecorator('zipcode', {
                        initialValue: this.state.student.ZipCode,
                        rules: [{ required: true, message: 'Please input your zip code!' },
                        {
                            validator: this.checkZipCode,
                        }
                        ],
                    })(
                        <Input style={{ width: '100%' }} />
                    )}
                </FormItem>
                {/*------------------------------------------ CONTACT ------------------------------------------*/}
                <FormItem {...formItemLayout} label="Phone Number">
                    {getFieldDecorator('phone', {
                        initialValue: this.state.student.PhoneNumber,
                        rules: [{ required: true, message: 'Please input your phone number!' },
                        {
                            validator: this.checkZipPhone,
                        }],
                    })(
                        <Input style={{ width: '100%' }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout} label="Email">
                    {getFieldDecorator('email', {
                        initialValue: this.state.student.Email,
                        rules: [{
                            type: this.state.emailValidatorInfo, message: 'The input is not a valid e-mail!'
                        }, {
                            required: true, message: 'Please input your email!',
                        }, {
                            validator: this.checkConfirm,
                        }],
                    })(
                        <Input onBlur={this.handleEmailValidation} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Select Employer from the List"
                >
                    <Select
                        showSearch
                        defaultValue={this.companydropdown}
                        style={{ width: '100%' }}
                        searchPlaceholder="Enter Company Name"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        onChange={this.handleChangeEmployer}
                    >
                        {this.employerDisplayList}

                    </Select>
                </FormItem>{/*Company Name*/}
                <FormItem {...formItemLayout} label="Company Name" style={{ display: this.state.employerNotList ? 'none' : 'block' }}>
                    {getFieldDecorator('company', {
                        initialValue: this.state.employer.CompanyName
                    })
                        (<Input disabled={this.state.hideTextbox} />)
                    }
                </FormItem>

                {/*Street*/}
                <FormItem {...formItemLayout} label="Street" style={{ display: this.state.employerNotList ? 'none' : 'block' }} >
                    {getFieldDecorator('streetCompany', {
                        initialValue: this.state.employer.Address
                    })(<Input disabled={this.state.hideTextbox} />)}
                </FormItem>

                {/*City*/}
                <FormItem {...formItemLayout} label="City" style={{ display: this.state.employerNotList ? 'none' : 'block' }}>
                    {getFieldDecorator('cityCompany', {
                        initialValue: this.state.employer.City
                    })(<Input disabled={this.state.hideTextbox} />)}
                </FormItem>

                {/*State*/}

                <FormItem {...formItemLayout} label="State" style={{ display: this.state.employerNotList ? 'none' : 'block' }}>
                    {getFieldDecorator('stateCompany', {
                        initialValue: this.state.employer.State
                    })(
                        <Select
                            disabled={this.state.hideTextbox}
                            showSearch
                            style={{ width: '40%' }}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.stateList}
                        </Select>)}
                </FormItem>

                {/*Zipcode*/}

                <FormItem {...midFormItemLayout} label="Zip Code" style={{ display: this.state.employerNotList ? 'none' : 'block' }}>
                    {getFieldDecorator('zipcodeCompany', {
                        initialValue: this.state.employer.ZipCode
                    })(
                        <Input style={{ width: '100%' }} disabled={this.state.hideTextbox} />
                    )}
                </FormItem>

                {/*Phone number*/}

                <FormItem {...formItemLayout} label="Phone Number" style={{ display: this.state.employerNotList ? 'none' : 'block' }}>
                    {getFieldDecorator('phoneCompany', {
                        initialValue: this.state.employer.PhoneNumber
                    })(
                        <Input style={{ width: '100%' }} disabled={this.state.hideTextbox} />
                    )}
                </FormItem>

                {/*Email*/}

                <FormItem {...formItemLayout} label="Employer E-mail" >
                    {getFieldDecorator('emailCompany', {
                        initialValue: this.state.employer.Email
                    })(
                        <Input disabled={this.state.hideTextbox} onBlur={this.handleEmailValidationEmployer} />
                    )}
                </FormItem>
                <button className="btn btn-default" onClick={() => this.addStudent()} style={{ float: 'right' }}>Add Student</button>
            </div>
        );
    }
    getDateOfBirth = (date) => {

        this.props.form.setFieldsValue({
            ['DOBEx']: date,
        });
        this.DobUser = date;
    }
    /**
    * Personal Data Entry form
    */
    getDateOfBirthNew = (date) => {

        this.props.form.setFieldsValue({
            ['dob']: date,
        });

    }
    handleEmailValidationEmployer = (e) => {
        this.setState({
            emailValidatorEmployer: 'email',
        },
            () => {
                this.props.form.validateFields(['emailCompany'], { force: true });
            });
    }

    addStudent = async (e) => {
        this.setState({ visible: false });
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const student = this.state.student;
                student.FirstName = this.capitalize(values.fname);
                student.LastName = this.capitalize(values.lname);
                student.MiddleInitial = values.mname;
                student.DLN = values.dln;
                student.StreetAddress = values.street;
                student.State = values.state;
                student.City = values.city;
                student.ZipCode = values.zipcode;
                student.PhoneNumber = values.phone;
                student.Email = values.email;
                student.DateofBirth = values.dob;

                this.setState({
                    student
                });

                const employer = this.state.employer;
                employer.CompanyName = values.company;
                employer.Address = values.streetCompany;
                employer.State = values.stateCompany;
                employer.City = values.cityCompany;
                employer.ZipCode = values.zipcodeCompany;
                employer.PhoneNumber = values.phoneCompany;
                employer.Email = values.emailCompany;
                this.setState({
                    employer
                });

                let studEmp = { stud: this.state.student, emp: this.state.employer };
                $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/registration/student`,
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify(studEmp)
                })
                    .done((data) => {
                        //console.log(data);
                        const modal = Modal.success({
                            title: "Student registration successful!",
                            content: 'They will now be able to be registered for classes.',
                            onOk() {
                            }
                        });
                    })
                    .fail((jqXhr) => {
                        console.log('failed to register');
                        this.setState({
                            loading: false
                        });
                        const modal2 = Modal.error({
                            title: "Student registration failed!",
                            content: 'Server Error',
                        });
                    });
                $.ajax({
                    type: 'GET',
                    url: `${config.serverUrl}/api/students/getall`
                })
                    .done((data) => {
                        this.state.studentData = data
                        var seenNames = {};
                        this.array = data;
                        this.array = this.array.filter(function (currentObject) {
                            if (currentObject.LastName in seenNames) {
                                return false;
                            } else {
                                seenNames[currentObject.LastName] = true;
                                return true;
                            }
                        });
                        this.state.lastNameArr = this.array;
                    })
                    .fail((jqXHR, textStatus, errorThrown) => {
                        console.err('failed to get data');
                    });
                this.prev()
            }

        });
    }
    validateExisting = () => {
        var LastNameEx = this.capitalize(this.props.form.getFieldValue('lNameEx'));

        if (LastNameEx) {
            this.existingUser = { LastName: LastNameEx };
            $.ajax({
                type: 'POST',
                url: `${config.serverUrl}/api/registration/searchtech`,
                data: this.existingUser
            })
                .done((data) => {
                    // previous pop up box functionality removed since techId was always -1 meant it never popped up
                    this.setState({
                        visibleWarning: true,
                        tableWarning: data
                    });
                })
                .fail((jqXhr) => {
                    console.log("Failed to search");
                });
        }

        else {
            Modal.error({
                title: 'Error message',
                content: 'Last name is required',
            });

        }

    }

    capitalize(str) {
        if (str)
            return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });

    }

    handleChangeEmployer = (value) => {
        //this.props.form.resetFields();
        this.companydropdown = value;
        for (let i = 0; i < this.employerList.length; i++) {
            if (this.employerList[i].Id == value) {
                this.setState({
                    employer: this.employerList[i]
                });

                this.setState({
                    inputControl: false
                });
                break;
            }
            else {
                this.setState({
                    employer: {
                        Id: -1, CompanyName: 'Employer Not Available', Address: 'n/a', State: 'n/a',
                        City: 'n/a', ZipCode: 'n/a', PhoneNumber: 'n/a', Email: 'n/a'
                    }
                });
            }

        }
        this.setState({
            inputControl: false
        });

    }
    //This is for searching columns for values
    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    size="small"
                    style={{ width: 90 }}
                >
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        confirm({ closeDropdown: false });
                        this.setState({
                            searchText: selectedKeys[0],
                            searchedColumn: dataIndex,
                        });
                    }}
                >
                    Filter
                </Button>
            </div>
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
        render: text => text,

    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    /**
    * Second transition handler
    */
    secondPage = () => {
        const { getFieldDecorator } = this.props.form;
        /*------------------------------------------ User Login Page ------------------------------------------*/
        return (
            <div>
                {this.getClassData()}
                {this.getMenuData()}
            </div>
        );
    }

    getClassData() {
        if (this.state.classData[0].ClassModeID == 3) {
            return (
                "In-Person Capacity:" + this.state.classData[0].Capacity +
                "  Online Capacity:" + this.state.classData[0].OnlineCapacity
            )
        }
    }

    //Second page table button controller
    //Changes the button to submit or start new registraton
    onSelectChange = (selectedRowKeys, selectedRows) => {
        for (let x = 0; x < selectedRows.length; x++) {
            if (!this.state.selectedStudents.includes(selectedRows[x])) {
                this.state.selectedStudents.push(selectedRows[x])
            }
        }
        this.setState({
            selectedRowKeys: [],
            selectedRows: []
        });
    };

    onRemove = (selectedRows) => {
        if (selectedRows.length >= this.state.selectedStudents.length) {
            this.setState({
                selectedStudents: []
            });
            this.state.attendanceMap.clear()
        } else {
            var selectedStudentIds = this.state.selectedStudents.map((student) => student.StudentId)
            for (let x = 0; x < selectedStudentIds.length; x++) {
                if (selectedRows.includes(selectedStudentIds[x])) {
                    this.state.attendanceMap.delete(selectedStudentIds[x])
                    this.state.selectedStudents.splice(x, 1)
                    break;
                }
            }
        }
        console.log(this.state.attendanceMap)
        this.setState({
            selectedRowKeys: [],
            selectedRows: [],
            topSelectedRows: []
        });
    };

    /**
        * Display menu for existing users (similar to editStudent page)
        */
    getMenuData() {

        // if (this.state.currentMenu === 'Yes') {
        const { getFieldDecorator } = this.props.form;
        const { selectedRowKeys, selectedRows, topSelectedRows } = this.state;
        const rowSelection = {
            selectedRowKeys,
            selectedRows,
            onChange: this.onSelectChange,
        };
        const topRowSelection = {
            topSelectedRows,
            onChange: this.onRemove,
        };

        const ListColumns = [
            {
                title: 'Name',
                dataIndex: 'FirstName',
                key: 'FirstName',
                sorter: (a, b) => a.FirstName.localeCompare(b.FirstName)

            },
            {
                title: 'Middle Initial',
                dataIndex: 'MiddleInitial',
                key: 'MiddleInitial'
            },
            {
                title: 'Last Name',
                dataIndex: 'LastName',
                sorter: (a, b) => a.LastName.localeCompare(b.LastName),
                ...this.getColumnSearchProps('LastName')
            },
            ,
            {
                title: 'Employer',
                dataIndex: 'CompanyName',
                render: (text, record, index) => {
                    let emp = 'Not Available';
                    if (record.CompanyName) {
                        emp = record.CompanyName + ", " + record.EmployerCity + " (" + record.EmployerState + ")"
                    }
                    return (
                        <div>{emp}</div>
                    );
                },
            }, {
                title: 'Attendance Selection',
                dataIndex: 'ClassModeAttendenceID',
                key: 'ClassModeAttendenceID',
                render: (text, record, index) => {
                    // if hybrid course, select attendance
                    if (this.state.classData[0].ClassModeID === 3) {
                        // if on the first page, give options
                        if (this.state.current === 1) {
                            this.state.onlineDisable = this.state.classData[0].OnlineCapacity === 'Capacity Full';
                            this.state.personDisable = this.state.classData[0].Capacity === 'Capacity Full';
                            return (
                                <Select
                                    title="Selection for {class}"
                                    placeholder="Attendance Selection"
                                    onChange={(optID) => { this.handleSelectClassModeChoice(optID, record) }}
                                    style={{ width: 120 }}>
                                    <Option value="Online">Online</Option>
                                    <Option value="In Person">In Person</Option>
                                </Select>
                            )
                        }
                        // on any other page (page 4), only display what's selected
                        else {
                            // !!! currently if they don't select on first page this won't show anything !!!
                            return record.ChosenAttendance
                        }

                    } else {
                        return (
                            convertClassModeIDtoName(this.state.classData[0].ClassModeID)
                        )
                    }
                }
            }
        ];
        const Columns = [
            {
                title: 'Name',
                dataIndex: 'FirstName',
                key: 'FirstName',
                sorter: (a, b) => a.FirstName.localeCompare(b.FirstName)

            },
            {
                title: 'Middle Initial',
                dataIndex: 'MiddleInitial',
                key: 'MiddleInitial'
            },
            {
                title: 'Last Name',
                dataIndex: 'LastName',
                sorter: (a, b) => a.LastName.localeCompare(b.LastName),
                ...this.getColumnSearchProps('LastName')
            },
            ,
            {
                title: 'Employer',
                dataIndex: 'CompanyName',
                render: (text, record, index) => {
                    let emp = 'Not Available';
                    if (record.CompanyName) {
                        emp = record.CompanyName + ", " + record.EmployerCity + " (" + record.EmployerState + ")"
                    }
                    return (
                        <div>{emp}</div>
                    );
                },
            }
        ];
        return (
            <div>

                <Modal
                    visible={this.state.userVisible}
                    title={this.existingUserName}
                    onOk={this.handleUserYes}
                    onCancel={this.handleUserCancel}
                    footer={[
                        <button className="btn btn-default" key="back" size="large" onClick={this.handleUserCancel}>No</button>,
                        <button className="btn btn-default" key="submit" type="primary" size="large" onClick={this.handleUserYes}>
                            Yes
                        </button>,
                    ]}
                >
                </Modal>
                <div>
                    <br />
                    <br />
                    <Card style={{ width: 1150 }}>
                        <Row gutter={8}>
                            <Col span={15} style={{ 'textAlign': 'center', }} >
                                <FormItem  {...formItemLayout} label="Enter First or Last Name*">
                                    {getFieldDecorator('lNameEx')(
                                        <Input />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={6} style={{ 'textAlign': 'center', }} >
                                <button style={{ 'color': 'black', margin: 'auto', display: 'block' }} className="btn btn-default" onClick={() => this.validateExisting()}>Search</button>

                            </Col>
                        </Row>
                    </Card>
                    <br />
                    {this.state.selectedStudents.length > 0 ? (
                        <div>
                            Selected Students (Select To Remove From List):
                            <Table rowKey="StudentId" rowSelection={topRowSelection} columns={ListColumns} dataSource={this.state.selectedStudents} size="small" bordered />

                            <br />
                            <br />
                        </div>
                    ) : <div></div>}

                    {this.state.visibleWarning ? (
                        <div>
                            <br />
                            Search Results (Select To Add To List):
                            <Table rowKey="StudentId" rowSelection={rowSelection} columns={Columns} dataSource={this.state.tableWarning} size="small" bordered />

                            <br />
                        </div>
                    ) : <div></div>}
                </div>

            </div>
        );
    }

    resetData = (e) => {
        this.props.form.resetFields();
        //this.existingUserData = '';
        this.setState({
            employer: {
                Id: -1, CompanyName: '', Address: '', State: 'ND',
                City: '', ZipCode: '', PhoneNumber: '', Email: ''
            },
            student: {
                Id: -1, FirstName: '', MiddleInitial: '', LastName: '', DLN: '', DateofBirth: '',
                StreetAddress: '', State: 'ND', City: '', ZipCode: '', PhoneNumber: '', Email: '', TechID: 'To be assigned', SComments: ''
            },
            //filledMenuDisplay: false,
            currentMenu: 'Yes'
        });
    }

    thirdPage = () => {
        const { getFieldDecorator } = this.props.form;
        const Columns = [
            {
                title: 'First Name',
                dataIndex: 'FirstName'
            },
            {
                title: 'Last Name',
                dataIndex: 'LastName'
            },
            {
                title: 'Student Email',
                dataIndex: 'Email'
            },
            {
                title: 'Attendance Mode',
                dataIndex: 'AttendanceMode'
            },
        ];
        var data = [];
        for (var i = 0; i < this.state.selectedStudents.length; i++) {
            var temp = {
                "FirstName": this.state.selectedStudents[i].FirstName,
                "LastName": this.state.selectedStudents[i].LastName,
                "Email": this.state.selectedStudents[i].Email == "" ? "NA" : this.state.selectedStudents[i].Email,
                "AttendanceMode": this.state.classData[0].ClassModeID == 3 ? this.state.attendanceMap.get(this.state.selectedStudents[i].StudentId) : convertClassModeIDtoName(this.state.classData[0].ClassModeID)
            };
            data.push(temp);
        }

        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <Table rowKey="Id" columns={this.columnsSelect()} dataSource={this.state.classData} size="small" bordered />
                    <br />
                    <br />
                    <Table rowKey="StudentInfo" columns={Columns} dataSource={data} size="small" bordered />
                </Spin>
                <br />
                <br />
                <br />
            </div>
        );
    }

    //Functions used to display verification model
    adminThird = () => {
        const { getFieldDecorator } = this.props.form;
        const Columns = [
            {
                title: 'First Name',
                dataIndex: 'FirstName'
            },
            {
                title: 'Last Name',
                dataIndex: 'LastName'
            },
            {
                title: 'Student Email',
                dataIndex: 'Email'
            }, {
                title: 'Attendance Mode',
                dataIndex: 'AttendanceMode'
            },

        ];
        var data = [];
        for (var i = 0; i < this.state.selectedStudents.length; i++) {
            var temp = {
                "FirstName": this.state.selectedStudents[i].FirstName,
                "LastName": this.state.selectedStudents[i].LastName,
                "Email": this.state.selectedStudents[i].Email == "" ? "NA" : this.state.selectedStudents[i].Email,
                "AttendanceMode": this.state.classData[0].ClassModeID == 3 ? this.state.attendanceMap.get(this.state.selectedStudents[i].StudentId) : convertClassModeIDtoName(this.state.classData[0].ClassModeID)
            };
            data.push(temp);
        }

        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <Table rowKey="Id" columns={this.columnsSelect()} dataSource={this.state.classData} size="small" bordered />
                    <br />
                    <br />
                    <Table rowKey="StudentInfo" columns={Columns} dataSource={data} size="small" bordered />
                </Spin>
                <br />
                <div id="emailDropdown">
                    Email*:
                    <br />
                    <Select
                        style={{ width: '450px' }}
                        value={this.state.emailValue}
                        onChange={this.handleEmailSelectChangeSystem}>
                        <Option value="Both">Send Email To Both Students And Employer</Option>
                        <Option value="Employer">Send Email To Employer</Option>
                        <Option value="Student">Send Email To Students</Option>
                        <Option value="None">Do Not Send Email</Option>
                    </Select>
                </div>
                <br />
                <br />
            </div>
        );
    }

    handleEmailSelectChangeSystem = (value) => {
        this.setState({ emailValue: value });
    }

    //Used to assign the type of system using
    handleSelectChangeSystem = (value) => {
        this.setState({ filterSystem: value, initialModal: false });
    }
    //Gets the selected class list
    setSelectedData = (value, keys) => {
        this.setState({
            classData: value,
            classDataKeys: keys
        });
    }
}

const WrappedRegistrationForm = Form.create()(RegistrationForm);

export default WrappedRegistrationForm;




// WEBPACK FOOTER //
// ./src/Registration/MultiStudentRegistration.js